<div class="upload-loading" style="z-index: 9999" *ngIf="disableSend">
  <div>
    <img src="assets/img/ajax-loader.gif" alt="Loading" />
  </div>
</div>

<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">
    Client Tasks<span *ngIf="isDraft"> Draft</span>
  </h4>
</div>
<div class="modal-body new-tracked-item-modal-body" style="overflow: hidden">
  <div class="row modal-row d-flex" *ngIf="isBatch" style="margin-bottom: 20px">
    <div class="col-sm-12 col-md-12 d-flex flex-column left-column">
      <label class="h5"
        >Tasks will be sent to: {{ conversations.length }} selected
        {{ conversations.length > 1 ? "workspaces" : "workspace" }}</label
      >
    </div>
  </div>
  <div class="row modal-row d-flex">
    <div
      class="col d-flex flex-column left-column"
      *ngIf="tracked_items.length > 0"
    >
      <div class="sticky-top">
        <div class="form-group">
          <label class="h5"
            ><i class="feather align-left"></i>
            <span style="font-weight: 600"> Client Task / Question</span></label
          >
          <p-editor
            #pEditor
            [(ngModel)]="tracked_item.message"
            [style]="{ height: '19vh' }"
            [placeholder]="'Enter your client task here'"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-font ql-picker">
                  <option selected>Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select
                  title="Text Color"
                  class="ql-color"
                  defaultValue="rgb(0, 0, 0)"
                ></select>
                <span class="ql-format-separator"></span>
                <select
                  title="Background Color"
                  class="ql-background"
                  defaultValue="rgb(255, 255, 255)"
                ></select>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered" type="button"></button>
                <button class="ql-list" value="bullet" type="button"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button aria-label="Image" class="ql-image"></button>
              </span>
            </p-header>
          </p-editor>

          <!-- <div class="upload-wrapper" [ngClass]="{ 'border-top': selectedFiles.length > 0 }">
            <div
              class="file-upload-preview generic {{ selectedFile.ext }} item{{ i }}" style="background: url('{{selectedFile.url}}')"
              *ngFor="let selectedFile of selectedFiles; let i = index"
            >
              <div class="file-name">{{ selectedFile.filename }}</div>
              <button class="remove-uploaded-file" (click)="removeFile(i)">
                <i class="feather x"></i>
              </button>
            </div>
          </div> -->
        </div>

        <div class="client-task-modal-attachments">
          <label class="h5" style="margin: 0"
            ><i class="feather paperclip"></i>
            <span style="font-weight: 600"> Attachments to Send</span>
            <button (click)="debug()"></button>
            <span class="optional-label ms-2">(Optional)</span>
          </label>

          <div class="file-items">
            <div
              class="file-item"
              *ngFor="let selectedFile of tracked_item.files; let i = index"
            >
              <i
                class="file-icon file-{{ selectedFile.ext }}"
                style="background: url('{{ selectedFile.url }}')"
              ></i>
              <div class="file-name" title="{{ selectedFile.filename }}">
                {{ selectedFile.filename }}
              </div>
              <a class="color-red-hover">
                <i class="feather trash-2" (click)="removeFile(i)"></i>
              </a>
            </div>
          </div>

          <app-progress-bar
            *ngIf="showProgressBar"
            [percentage]="progressPercentage"
            style="display: block; margin: 0 20px"
          ></app-progress-bar>

          <div
            (click)="openModalFileUpload()"
            class="new-tracked-item"
            style="
              padding: 5px 16px;
              width: 135px;
              margin-left: 20px;
              font-size: 1rem;
              margin-bottom: 20px;
            "
          >
            <i class="feather upload" style="font-size: 16px"></i> Select files
          </div>
        </div>

        <div class="form-group">
          <label class="h5" style="margin: 0"
            ><i class="feather check-circle"></i>
            <span style="font-weight: 600">
              Client Response Requested</span
            ></label
          >
          <div class="row">
            <div class="col-md-6">
              <div class="checkbox new-tracked-item-checkbox">
                <label
                  ><input
                    type="radio"
                    [value]="'5'"
                    [(ngModel)]="tracked_item.type"
                    name="type"
                  />
                  To Do</label
                >
                <label
                  ><input
                    type="radio"
                    [value]="'1'"
                    [(ngModel)]="tracked_item.type"
                    name="type"
                  />
                  Yes/No</label
                >
                <label
                  ><input
                    type="radio"
                    [value]="'2'"
                    [(ngModel)]="tracked_item.type"
                    name="type"
                  />
                  File</label
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="checkbox new-tracked-item-checkbox">
                <label
                  ><input
                    type="radio"
                    [value]="'3'"
                    [(ngModel)]="tracked_item.type"
                    name="type"
                  />
                  Open Text</label
                >
                <label
                  ><input
                    type="radio"
                    [value]="'4'"
                    [(ngModel)]="tracked_item.type"
                    name="type"
                  />
                  Accept/Decline</label
                >
              </div>
            </div>
          </div>
        </div>

        <div
          class="form-group flex-grow"
          *ngIf="tracked_item.type == 2 && !editTemplateMode"
        >
          <label class="h5" style="margin: 0"
            ><i class="feather check-circle"></i>
            <span style="font-weight: 600">
              Select a folder to receive the uploaded files</span
            >
            <p class="optional-label">(Optional)</p>
          </label>
          <div
            (click)="openModalFolderUpload()"
            class="new-tracked-item select-folder"
            title="{{ selectedFolderToUploadName }}"
          >
            <i class="feather folder" style="font-size: 16px"></i>
            {{ selectedFolderToUploadName }}
          </div>
        </div>
      </div>
    </div>

    <div class="col right-column" style="overflow-y: auto">
      <div class="tracked-items-preview scrollbars">
        <div class="request-header">
          <label class="pull-left h4 m-0" style="margin-top: 9px"
            ><i class="feather card-view"></i>
            <span class="bold"> Preview</span></label
          >
          <form
            class="choose-template no-animation choose-template-modal"
            [formGroup]="templatesForm"
            *ngIf="!editMode"
          >
            <input
              #templateList
              formControlName="templates"
              [typeahead]="templates"
              (typeaheadOnSelect)="typeaheadOnSelect($event)"
              [typeaheadOptionsLimit]="9999"
              [typeaheadMinLength]="0"
              typeaheadOptionField="name"
              placeholder="Load from templates"
              class="form-control"
            />
          </form>
        </div>

        <div
          class="message-bubble tracked-item created"
          [ngClass]="{ focus: item.focused }"
          *ngFor="let item of tracked_items; let i = index; trackBy: identify"
          (click)="toggleFocus(item)"
        >
          <div class="message-bubble-wrapper">
            <div
              style="pointer-events: none"
              class="client-task-placeholder"
              *ngIf="
                item.message == '' ||
                item.message == null ||
                item.message == '<p></p>'
              "
            >
              <p>Enter your Client Task on the left</p>
            </div>
            <div
              style="pointer-events: none"
              class="ql-editor p-0 pb-2"
              *ngIf="
                !item.focused || item.message !== '' || item.message !== null
              "
              [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.message)"
            ></div>
            <div
              class="message-bubble-separator"
              style="border-top: 1px solid #ebedf0; padding-top: 15px"
            ></div>
            <div class="tracked-item-footer">
              <ng-container *ngIf="item.type == 1">
                <div
                  class="tracked-item-options"
                  [style]="
                    item.message != '' &&
                    item.message != null &&
                    item.message != '<p></p>'
                      ? { opacity: 1 }
                      : { opacity: 0.4 }
                  "
                >
                  <label
                    ><input type="radio" name="question" value="1" disabled />
                    Yes</label
                  >
                  <label
                    ><input type="radio" name="question" value="0" disabled />
                    No</label
                  >
                  <label
                    ><input type="radio" name="question" value="2" disabled />
                    Not Sure</label
                  >
                  <a
                    class="color-red-hover"
                    (click)="removeTrackedItem(i)"
                    style="float: right; margin-right: -20px"
                  >
                    <i class="feather trash-2"></i>
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 2">
                <div
                  class="tracked-item-options"
                  [style]="
                    item.message != '' &&
                    item.message != null &&
                    item.message != '<p></p>'
                      ? { opacity: 1 }
                      : { opacity: 0.4 }
                  "
                >
                  <label class="file"
                    ><input
                      type="file"
                      accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.ofx,.qbo,.iif,.qbx,.qbm,.qbb,.qbw"
                      readonly
                      disabled
                      name="file"
                      value="Yes"
                    /><i class="feather upload"></i>
                    <span class="text"> Select file(s) to upload</span></label
                  >
                  <a
                    class="color-red-hover"
                    (click)="removeTrackedItem(i)"
                    style="float: right; margin-right: -20px"
                  >
                    <i class="feather trash-2"></i>
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 3">
                <div
                  class="tracked-item-options new-open-text"
                  [style]="
                    item.message != '' &&
                    item.message != null &&
                    item.message != '<p></p>'
                      ? { opacity: 1 }
                      : { opacity: 0.4 }
                  "
                >
                  <!-- <label> -->

                  <!-- <ejs-richtexteditor
                    name="test-2"
                    ngDefaultControl
                    id="tracked-item-message"
                    [placeholder]="'Client response'"
                    [insertImageSettings]="jobsService.insertImageSettings"
                    (imageUploading)="jobsService.addHeaders($event)"
                    (imageUploadSuccess)="jobsService.onUploadSuccess($event)"
                    [saveInterval]="jobsService.saveInterval"
                    [toolbarSettings]="jobsService.clientTaskToolbarSettings"
                    [autoSaveOnIdle]="true"
                    [enabled]="false"
                  >
                  </ejs-richtexteditor> -->
                  <p-editor [readonly]="true" />
                  <!-- </label> -->
                  <a
                    class="color-red-hover"
                    (click)="removeTrackedItem(i)"
                    style="float: right; margin-right: -20px"
                  >
                    <i class="feather trash-2"></i>
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 4">
                <div
                  class="tracked-item-options"
                  [style]="
                    item.message != '' &&
                    item.message != null &&
                    item.message != '<p></p>'
                      ? { opacity: 1 }
                      : { opacity: 0.4 }
                  "
                >
                  <label
                    ><input type="radio" name="question" value="3" disabled />
                    Accept</label
                  >
                  <label
                    ><input type="radio" name="question" value="4" disabled />
                    Decline</label
                  >
                  <a
                    class="color-red-hover"
                    (click)="removeTrackedItem(i)"
                    style="float: right; margin-right: -20px"
                  >
                    <i class="feather trash-2"></i>
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 5">
                <div
                  class="tracked-item-options"
                  [style]="
                    item.message != '' &&
                    item.message != null &&
                    item.message != '<p></p>'
                      ? { opacity: 1 }
                      : { opacity: 0.4 }
                  "
                >
                  <label
                    ><input type="checkbox" disabled name="todo" value="1" />
                    Mark as done</label
                  >
                  <a
                    class="color-red-hover"
                    (click)="removeTrackedItem(i)"
                    style="float: right; margin-right: -20px"
                  >
                    <i class="feather trash-2"></i>
                  </a>
                </div>
              </ng-container>
              <!-- <a class="tracked-item-button">Submit</a> -->
            </div>
          </div>
          <!-- <img class="new-tracked-item-tail" src="assets/img/new-tracked-item-tail.png" height="26" width="13"> -->
        </div>
        <div
          class="new-tracked-item"
          (click)="addTrackedItem()"
          *ngIf="!editMode || editTemplateMode"
        >
          <i class="feather plus-circle" style="font-size: 18px"></i> Add
          another Client Task
        </div>
      </div>
    </div>

    <div
      *ngIf="!editMode || tracked_items[0]['is_draft']"
      class="col-3 d-flex flex-column right-column"
      style="overflow: hidden"
    >
      <div class="container" style="overflow-y: auto">
        <span class="title">Task Settings</span>
        <p class="subtitle">Applies to all these Client Tasks</p>
        <label class="mt-2 d-flex align-items-center">
          <i class="tio-notifications_on_outlined"></i>
          <span
            class="title"
            style="font-size: 1rem; margin-left: 6.5px; margin-right: 2px"
            >Auto-Remind Client</span
          >
          <div
            class="switch-toggle"
            style="display: inline; vertical-align: 1px"
          >
            <div class="toggle-wrapper">
              <div class="toggle">
                <input
                  type="checkbox"
                  name="urgent"
                  class="check urgent"
                  [(ngModel)]="autoRemind"
                />
                <b class="b switch"></b>
                <b class="b track"></b>
              </div>
            </div>
          </div>
        </label>
        <div class="due-date-container" *ngIf="autoRemind">
          <i class="tio-calendar"></i>
          <span class="title" style="font-size: 1rem; margin-left: 6.5px"
            >Due date in N days</span
          >
          <div class="dropdown">
            <select
              id="autoRemindDaysSelect"
              class="form-control"
              name="autoRemindDaysSelect"
              [(ngModel)]="autoRemindDays"
            >
              <option value="1">1</option>
              <option value="2" selected>2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
            </select>
          </div>
        </div>

        @if (isDraft || editMode) {
          <div class="send-from-container mt-4 mb-2">
            <i class="tio-user_switch"></i>
            <span class="title" style="font-size: 1rem; margin-left: 6.5px"
              >Send from</span
            >
            <p-dropdown
              [options]="accountants"
              optionLabel="user.full_name"
              [(ngModel)]="sendFrom"
              [loading]="loadingAccountants"
            ></p-dropdown>
          </div>
        }

        @if (clientsToNotify) {
          <div class="notify-to-container mt-4 mb-2">
            <i class="tio-user_outlined"></i>
            <span class="title" style="font-size: 1rem; margin-left: 6.5px"
              >Notify to</span
            >
          </div>
        }

        <!-- User list -->
        <label
          *ngFor="let client of clientsToNotify"
          class="d-flex mb-2"
          style="gap: 8px"
        >
          <input
            [(ngModel)]="client.selected"
            type="checkbox"
            [checked]="client.selected"
          />
          <div class="avatar avatar-24">
            <div
              class="photo"
              *ngIf="client.picture_url"
              style="background-image: url('{{ client.picture_url }}')"
            ></div>
            <div class="initials" initials [name]="client.full_name"></div>
          </div>
          <span class="notify-username" title="{{ client.full_name }}">{{
            client.full_name
          }}</span>
        </label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <span
    class="dropdown dropup create-template-dropdown"
    dropdown
    [autoClose]="true"
    [insideClick]="true"
  >
    <span
      id="dLabel"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      dropdownToggle
    >
      <button
        type="button"
        class="btn btn-success"
        *ngIf="!isDraft && !editMode"
      >
        <i class="feather copy"></i> Save as template
      </button>
    </span>
    <div
      class="dropdown-menu no-animation"
      *dropdownMenu
      aria-labelledby="dLabel"
      style="padding: 0; border: none; margin-bottom: 10px"
    >
      <input
        type="text"
        class="form-control"
        [(ngModel)]="template_name"
        style="min-width: 230px; padding-right: 50px"
        placeholder="Template name"
      />
      <button
        type="button"
        (click)="newTrackedItemTemplate()"
        class="btn btn-primary btn-sm"
        style="position: absolute; right: 10px; top: 10px"
      >
        Save
      </button>
    </div>
  </span>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="disableSend"
    (click)="createTrackedItems()"
    *ngIf="!isDraft; else createDraft"
  >
    {{ editMode ? "Save Changes" : "Send and Notify" }}
  </button>
</div>
<ng-template #createDraft>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="disableSend"
    (click)="createDrafts()"
  >
    Add to Job
  </button>
</ng-template>
